export default "<ul class=\"guidenceList\">\n    <li *ngFor=\"let item of label; let i = index\" (click)=\"openModal(i)\">{{item}}</li>\n</ul>\n"